import { defineStore } from 'pinia'
import { ref, toRaw, watch } from 'vue'

/**
 * 用户状态管理 Store
 * 负责用户偏好设置修改
 */
export const usePreferenceStore = defineStore('preference', () => {
  const start = ref<{ auto: boolean; silence: boolean }>({
    auto: false,
    silence: false,
  })
  const closeBehavior = ref<'minimize' | 'exit'>('minimize')
  const notificationEnabled = ref(true)

  const initPreference = async () => {
    start.value = await window.electronAPI?.storeGet('start')
    closeBehavior.value = await window.electronAPI?.storeGet('closeBehavior')
    notificationEnabled.value = (await window.electronAPI?.storeGet('notificationEnabled')) ?? true
  }

  const saveStart = async () => {
    await window.electronAPI?.storeSet('start', toRaw(start.value))
  }
  watch(
    () => start.value,
    async (val, oldVal) => {
      if (val?.auto != oldVal.auto) {
        await window.electronAPI?.setAppAutoLaunch(val?.auto)
      }
      saveStart()
    },
    { deep: true },
  )

  const saveCloseBehavior = async () => {
    await window.electronAPI?.storeSet('closeBehavior', toRaw(closeBehavior.value))
  }
  watch(() => closeBehavior.value, saveCloseBehavior)

  const saveNotificationEnabled = async () => {
    await window.electronAPI?.storeSet('notificationEnabled', notificationEnabled.value)
  }
  watch(() => notificationEnabled.value, saveNotificationEnabled)

  return {
    start,
    closeBehavior,
    notificationEnabled,
    initPreference,
    saveStart,
    saveCloseBehavior,
    saveNotificationEnabled,
  }
})
